import React from 'react';
import styles from './FindIdSuccessPanel.module.css'; 
import { InnocodeButton } from '@intsoft/innocode-core';

function FindIdSuccessPanel({ onNext, userId }) {
  return (
    <div className={styles.content_wrapper}>
      <div className={styles.signup_section}>
        <div className={styles.success_content}>
          <div className={styles.icon_box}>
            <img
              src="/assets/circles_success-icon.svg"
              alt="success-icon"
              className={styles.success_icon}
            />
          </div>
          <div className={`innocode-typography--title-sm innocode-typography--bold ${styles.title_text}`}>
            ID를 성공적으로 찾았습니다.
          </div>
          {userId !== '' ?
            <div className={`innocode-typography--body-sm-reading innocode-typography--semibold ${styles.description_text}`}>
              {userId}
            </div>
            :  
            <div className={`innocode-typography--body-sm-reading innocode-typography--semibold ${styles.description_text}`}>
              본인인증이 완료된 계정이 없습니다.
            </div>
          }
        </div>
      </div>
      <div className={styles.submit_btn_container}>
        <InnocodeButton
          size="lg"
          onClick={onNext}
          className={styles.submit_btn}
        >
          완료
        </InnocodeButton> 
      </div>
    </div>
  );
}
export default FindIdSuccessPanel;


